<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"  @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE  ref="childUpdate"  @submit="submit" :updateData="updateData"></UPDATE>
  </div>
</template>

<script>
    //table封装组件
    import tablePage from '../components/page/table.vue'
    import FORM from '../components/page/form.vue'
    import UPDATE from '../components/page/update.vue'
    import DataUtil from '@/views/mis/util/data'
    
    //接口地址url的统一管理
    import URL from '@/views/mis/util/url'
    import DateUtil from '@/utils/IM/tradeDataUtil.js'
    import Qs from 'qs'
    import axios from 'axios'
    
    let type = {0:"关闭",1:"启用"};
    export default {
        name: 'list',
        components: {
            tablePage,
            FORM,
            UPDATE
        },
        methods: {
            /*表格按钮点击事件*/
            bthClick (clickName, row) {
                if (clickName == "update"){
                    this.$refs.childUpdate.open(row);
                } else if (clickName == "delete"){
                    this.dataChanage(URL.email.deleteChannelId,{id:row.id},res =>{
                        if (res.code == 0){
                            this.$message.success("suc");
                        }else{
                            this.$message.error(res.message);
                        }
                    });
                } else if (clickName == "changeEnabled"){
                    this.dataChanage(URL.email.changeChannelEnabled,{enabled:row.enabled,id:row.id},res =>{
                        if (res.code == 0){
                            this.$message.success("suc");
                        }else{
                            this.$message.error(res.message);
                        }
                    });
                }
            },
            /*查询表单按钮点击事件*/
            formclick(clickName, data){
                if("查询" == clickName || window.$t('mis.bt.query') == clickName){
                    this.queryData = data;
                    this.$refs.childTable.defaultGetData(data);
                }else if(window.$t('mis.bt.add') == clickName){
                    this.$refs.childUpdate.open();
                }
            },
            /*新增或跟提交数据触发事件*/
            submit(model){
                if (!this.validateEmail(model.emailAddress)) {
                    this.$message.error("电邮地址格式不对!!");
                    return;
                } else if (model.channelName==null||model.channelName.trim().length === 0) {
                    this.$message.error("通道名称不能为空!!");
                    return;
                } else {
                    //根据是否包含id更新还是添加
                    this.dataChanage(URL.email.addOrUpdateChannel,model,res => {
                        if (res.code == 0){
                            this.$refs.childUpdate.close();
                            this.$message.success(window.$t('mis.rewardDealList.confirmSuccess'));
                            this.$refs.childTable.defaultGetData(this.queryData);
                        }else{
                            this.$message.success(window.$t('mis.rewardDealList.confirmFail'));
                        }
                    })
                }
            },
            // check one email address
            validateEmail(email) {
                const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(String(email).toLowerCase());
            },
            dataChanage(url,option,suc,fail){
                this.$axios.post(url, Qs.stringify(option || {})).then(res => {
                    this.$refs.childTable.defaultGetData(this.queryData);
                    if(suc && (typeof suc == 'function')) suc(res);
                }).catch(res => {
                    if(fail && (typeof fail == 'function')) fail(res);
                })
            }
        },
        data () {
            return {
                queryData:{},
                /*from查询表单*/
                formData:{
                    hasLable: true,
                    cols:[
                        { title: window.$t('mis.emailChannel.channelName'), field: 'channelName'},
                        { title: window.$t('mis.emailChannel.emailAddress'), field: 'emailAddress'},
                        { title: window.$t('mis.emailChannel.enabled'), field: 'enabled',type: 2,optionList:type},
                        {click: window.$t('mis.bt.query')},
                        {click: window.$t('mis.bt.add')}
                    ]
                },
                updateData:{
                    cols:[
                        { title: 'id', field: 'id',hidden:true},
                        { title: window.$t('mis.emailChannel.channelName'), field: 'channelName'},
                        { title: window.$t('mis.emailChannel.emailAddress'), field: 'emailAddress'},
                        { title: window.$t('mis.emailChannel.enabled'), field: 'enabled',type:2,optionList:type,isNumber:true},                       
                    ]
                },
                /*table生成*/
                pageData: {
                    queryUrl: URL.email.channelQuery, //请求路径和参数
                    selection: true,
                    sequence: true,
                    cols: [
                        { title: window.$t('mis.emailChannel.channelName'), field: 'channelName'},
                        { title: window.$t('mis.emailChannel.emailAddress'), field: 'emailAddress'},
                        { title: window.$t('mis.emailChannel.enabled'), field: 'enabled', render: (data, full) => {
                            return type[data];
                        }},
                        { title: window.$t('mis.emailChannel.updateDate'), field: 'updateDate'},
                        {title:window.$t('mis.bt.operation'),btnClick:[{name:window.$t('mis.bt.edit'),click:"update",type:"primary",icon:"el-icon-edit"},{name:window.$t('mis.bt.delete'),click:"delete",type:"primary",icon:"el-icon-delete"},
                                    {name:(data,full)=>{
                                        if (full.enabled == 1) return window.$t('mis.bt.close');
                                        else return window.$t('mis.bt.enable');
                                    },click:"changeEnabled",type:"primary"}]},
                    ]
                }
            }
        }
    }
</script>
